var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _vm.isContentDisplay
      ? _c(
          "div",
          {
            staticClass:
              "internal-page-main-section employee-recognisation-main col-12"
          },
          [_vm._m(1)]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "internal-page-banner-main col-12" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "page-title" }, [
            _c("h1", [_vm._v(" Employee Recognition ")])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "h2",
          {
            staticClass:
              "color-red heading-text-24 line-height-28 font-text-semi-medium-mont float-l width-full"
          },
          [_vm._v(" 2021 President Award ")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "bottom-manager-section float-l col-12" }, [
          _c("div", { staticClass: "row" }, [
            _c("img", {
              staticClass: "manager-main-pic float-l",
              attrs: {
                src: "/static/images/Devin_Beck_Presidents_Award.jpg",
                alt: "Devin Beck"
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "manager-des-detail float-l" }, [
              _c(
                "div",
                { staticClass: "manager-des-detail-name float-l width-full" },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "color-blue heading-text-18 line-height-22 font-text-semi-medium-mont"
                    },
                    [_vm._v(" Devin Beck ")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "manager-des-detail-name float-l width-full" },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "color-888888 heading-text-16 line-height-22 font-text-semi-medium-mont"
                    },
                    [_vm._v(" Veloicty Vehicle Group ")]
                  )
                ]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "h2",
          {
            staticClass:
              "color-red heading-text-24 line-height-28 font-text-semi-medium-mont float-l width-full mt-5"
          },
          [_vm._v(" Manager of the Year ")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "bottom-manager-section float-l col-12" }, [
          _c("div", { staticClass: "row" }, [
            _c("img", {
              staticClass: "manager-main-pic float-l",
              attrs: {
                src: "/static/images/Aaron_Hunter_Manager_of_The_Year.jpg",
                alt: "Aaron Hunter"
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "manager-des-detail float-l" }, [
              _c(
                "div",
                { staticClass: "manager-des-detail-name float-l width-full" },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "color-blue heading-text-18 line-height-22 font-text-semi-medium-mont"
                    },
                    [_vm._v(" Aaron Hunter ")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "manager-des-detail-name float-l width-full" },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "color-888888 heading-text-16 line-height-22 font-text-semi-medium-mont"
                    },
                    [_vm._v(" Velocity Truck Center - Las Vegas ")]
                  )
                ]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bottom-employee-detail col-12 float-l" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "h2",
              {
                staticClass:
                  "color-red heading-text-24 line-height-28 font-text-semi-medium-mont float-l width-full"
              },
              [_vm._v(" 2021 Employee MVP’s ")]
            ),
            _vm._v(" "),
            _c("div", {}, [
              _c(
                "div",
                {
                  staticClass:
                    "bottom-employee-detail-left col-12 col-sm-6 col-md-6 col-lg-6"
                },
                [
                  _c(
                    "div",
                    { staticClass: "bg-color-table mt-60 float-l width-full" },
                    [
                      _c("p", { staticClass: "employee-department-name" }, [
                        _vm._v(" Manager of the Year Nomination ")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "bus-detail-row width-full float-l mt-20"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Mar Samayoa ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Great Dane ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Jesses Sanchez ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Fontana ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Jeff Smith ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [
                                  _vm._v(
                                    " Velocity Truck Center - Rocky Mount "
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Jason Roden ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Decatrur ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Gus Alfaro ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Chandler ")]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "bg-color-table mt-60 float-l width-full" },
                    [
                      _c("p", { staticClass: "employee-department-name" }, [
                        _vm._v(" Parts Department ")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "bus-detail-row width-full float-l mt-20"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Tammy Sudbrack ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" BUSWEST - Fontana ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Rogelio Gonzalez ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Transwest Truck Center ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Manuel Quimiro ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [
                                  _vm._v(
                                    " Velocity Truck & Trailer  - Bulk Warehouse "
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Johnny Garcia  ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [
                                  _vm._v(
                                    " Velocity Truck & Trailer  - Hesperia "
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Dario Celiz ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck & Trailer  - Otay ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Emanuel Rivera ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [
                                  _vm._v(
                                    " Velocity Truck & Trailer - El Centro "
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Frank Boutchyard ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck & Trailer - Nogales ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Heather Burton ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [
                                  _vm._v(
                                    " Velocity Truck Center - Bowling Green "
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Richard Gallmeier ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Madison ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Greg Polman ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Nashville ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Isaak Manai ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Carson ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Bridget Ibarra ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Chandler ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Bailey Robison ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Flagstaff ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Roman Hernandez ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Fontana ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Ezequiel Martinez ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Greensboro ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Calvin Wells ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Greenville ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Terry Lee ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Hope Mills ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Josh Teeple ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Hickory ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Alex Wells ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Kingsport ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Roy McDonald ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Canton ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Anthony Williams ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Raleigh ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" JR Tucker ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [
                                  _vm._v(
                                    " Velocity Truck Center - Rocky Mount "
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Daniel eaver ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Kingman ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Jon Eggert ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Oxnard ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Carissa Pierson ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Reno ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" David Solorzano ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - San Diego ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Shawn Abraham ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Tolleson ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Adrianna Lerma ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Tucson ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Marco Diaz ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Whittier ")]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "bg-color-table mt-60 float-l width-full" },
                    [
                      _c("p", { staticClass: "employee-department-name" }, [
                        _vm._v(" Information Technology ")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "bus-detail-row width-full float-l mt-20"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Andrew Kick ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [
                                  _vm._v(
                                    " Crossroads Equipment Lease & Finance "
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "bg-color-table mt-60 float-l width-full" },
                    [
                      _c("p", { staticClass: "employee-department-name" }, [
                        _vm._v(" Accounting Department ")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "bus-detail-row width-full float-l mt-20"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Vanessa Alday-Garcia ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [
                                  _vm._v(
                                    " Crossroads Equipment Lease & Finance "
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Arlene Lopez ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [
                                  _vm._v(
                                    " Velocity Truck Center - Fontana/Whittier "
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Jerome Concepcion ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [
                                  _vm._v(
                                    " Velocity Truck Center - Fontana/Whittier "
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "bg-color-table mt-60 float-l width-full" },
                    [
                      _c("p", { staticClass: "employee-department-name" }, [
                        _vm._v(" Documentation ")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "bus-detail-row width-full float-l mt-20"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Tyger Padilla ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [
                                  _vm._v(
                                    " Crossroads Equipment Lease & Finance "
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "bg-color-table mt-60 float-l width-full" },
                    [
                      _c("p", { staticClass: "employee-department-name" }, [
                        _vm._v(" Used Truck Department ")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "bus-detail-row width-full float-l mt-20"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Cissy Castillo ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Vehicle Group -Tolleson ")]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "bg-color-table mt-60 float-l width-full" },
                    [
                      _c("p", { staticClass: "employee-department-name" }, [
                        _vm._v(" New Truck Department ")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "bus-detail-row width-full float-l mt-20"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Wendy Laidlaw ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [
                                  _vm._v(
                                    " Velocity Truck Center - Fontana/Whittier "
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "bg-color-table mt-60 float-l width-full" },
                    [
                      _c("p", { staticClass: "employee-department-name" }, [
                        _vm._v(" Payroll Department ")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "bus-detail-row width-full float-l mt-20"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Eileen Garcia ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Corporate ")]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "bg-color-table mt-60 float-l width-full" },
                    [
                      _c("p", { staticClass: "employee-department-name" }, [
                        _vm._v(" Central Operations ")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "bus-detail-row width-full float-l mt-20"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Jeanette Arrearan ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Service & Bodyshop ")]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "bg-color-table mt-60 float-l width-full" },
                    [
                      _c("p", { staticClass: "employee-department-name" }, [
                        _vm._v(" Warranty Department ")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "bus-detail-row width-full float-l mt-20"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Josh Lucas ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Vehicle Group ")]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "bottom-employee-detail-right col-12 col-sm-6 col-md-6 col-lg-6"
                },
                [
                  _c(
                    "div",
                    { staticClass: "bg-color-table mt-60 float-l width-full" },
                    [
                      _c("p", { staticClass: "employee-department-name" }, [
                        _vm._v(" Administration Department ")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "bus-detail-row width-full float-l mt-20"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Evelyn Garcia ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" BUSWEST - Carson ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Cindy Lail ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Hickory ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Nancy Evans ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Canton ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Patrice Vick ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Raleigh ")]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "bg-color-table mt-60 float-l width-full" },
                    [
                      _c("p", { staticClass: "employee-department-name" }, [
                        _vm._v(" Human Resources ")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "bus-detail-row width-full float-l mt-20"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Cynthia Ortega ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Corporate ")]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "bg-color-table mt-60 float-l width-full" },
                    [
                      _c("p", { staticClass: "employee-department-name" }, [
                        _vm._v(" Body Shop ")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "bus-detail-row width-full float-l mt-20"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Jason Brent ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Ontario Collision Center ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Jordan McAnally ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Decatur ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Paul McClure  ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Nashville ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Tina Sims ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Greensboro ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Max Melton ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Hope Mills ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" James Phipps ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Hickory ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" David Wallace ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Kingsport ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Ashlee M Thomason ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Las Vegas ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Allen Edes ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Reno ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Jesus Hernandez ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Tolleson ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Jerry Juarez ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Whittier ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Victor Avalos ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - San Diego ")]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "bg-color-table mt-60 float-l width-full" },
                    [
                      _c("p", { staticClass: "employee-department-name" }, [
                        _vm._v(" Service Department ")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "bus-detail-row width-full float-l mt-20"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Fabian Bravo ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" BUSWEST - Woodland ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Kevin (Max) Bautista ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Transwest Truck Center ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Joshua Cervantes ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [
                                  _vm._v(
                                    " Velocity Truck & Trailer  - Hesperia "
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Mike Barnhart ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [
                                  _vm._v(
                                    " Velocity Truck Center - Bowling Green "
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Buddy McKendree ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Madison ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Jeff Randolph ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Nashville ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Martha Flores ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Carson ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Alex Hawkins ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Chandler ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Shannon Manson ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Flagstaff ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Benjamin Pangan ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Fontana ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Nick Foster ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Greensboro ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Scott Mills ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Greenville ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Bob Pfouts ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Hope Mills ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Keith Jarvis ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Hickory ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Brian Sims ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Kingsport ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Stephen Gajdosik ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Canton ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Matthew Carr ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Raleigh ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Ricky Howard ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [
                                  _vm._v(
                                    " Velocity Truck Center - Rocky Mount "
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Jason Giasson ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Kingman ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Oscar Luna ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Las Vegas ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Hector Armendariz ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Las Vegas ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Sergio Corres ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Oxnard ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" David Martinez-Millan ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Reno ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Alex Robledo ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - San Diego ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Jose Aguirre ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Tolleson ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Terry Brantley ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Tolleson ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Jacob Seeley ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Tucson ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Juan Mendoza ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Whittier ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Josecristo Perez-Campos ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Rental & Leasing ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Carlos Villa ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Rental & Leasing ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Joe Solano ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Rental & Leasing ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Maung Htut ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Rental & Leasing ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Jacob Jackson ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Rental & Leasing ")]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "bg-color-table mt-60 float-l width-full" },
                    [
                      _c("p", { staticClass: "employee-department-name" }, [
                        _vm._v(" Sprottruck ")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "bus-detail-row width-full float-l mt-20"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Kyle McKibben ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Center - Chandler ")]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "bg-color-table mt-60 float-l width-full" },
                    [
                      _c("p", { staticClass: "employee-department-name" }, [
                        _vm._v(" Finance Department ")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "bus-detail-row width-full float-l mt-20"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Lisa Jun ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" VelocitySBA ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Sharon Jeon ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" VelocitySBA ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Angel Flores ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [_vm._v(" Velocity Truck Rental & Leasing ")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bus-detail-row width-full float-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
                            },
                            [_c("p", { staticClass: "small-bullet center" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-area border-rt-white colpie-32 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-333333 heading-text-14 line-height-18"
                                },
                                [_vm._v(" Tyger Padilla ")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-inner-detail col-number colpie-60 float-l"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "color-blue heading-text-14 line-height-18"
                                },
                                [
                                  _vm._v(
                                    " Crossroads Equipment Lease & Finance "
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64a001a9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64a001a9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EmployeeRecognition.vue
// module id = null
// module chunks = 